import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import CompletedIcon from './icons/CompletedIcon'

const StartSectionBtn = ({ completed, section }) => {
    return (
        <Link className={`start-section-btn ${completed && "start-section-btn--completed"}`} to={`/menu/${section.secId}`}>
            <div className={`icon ${section.secId}-icon`} dangerouslySetInnerHTML={section.icon}></div>

            <div className="start-section-btn__text">
                <h4 className="bold">{ `${section.number}. ${section.title}` }</h4>
                <p>{ section.summary1 }</p>
                <p>{ section.summary2 }</p>
            </div>

            { completed && <CompletedIcon></CompletedIcon> }
        </Link>
    )
}

const mapStateToProps = (state, props) => {
    const section = state.tracker[props.section.secId]
    const subSections = Object.values(section)
    const incompleteSub = subSections.find(subSection => !subSection.completed)
    if (incompleteSub) {
        return {
            completed: false,
        }
    } else {
        return {
            completed: true,
        }
    }
}

export default connect(mapStateToProps)(StartSectionBtn)


// WEBPACK FOOTER //
// ./src/components/StartSectionBtn.js